module.exports = __webpack_public_path__ + "static/GRAPHQL-cb15d3c930fa61c26b20ea36eb908258.png";